import { render, staticRenderFns } from "./EmpleadoTarjetas.vue?vue&type=template&id=196718b2"
import script from "./EmpleadoTarjetas.vue?vue&type=script&lang=js"
export * from "./EmpleadoTarjetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports